function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#348C30;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M225.2,376.7c-10.3,0-18.6-8.4-18.6-18.6s8.4-18.6,18.6-18.6H398V153.8H210c-22.6,0-41,18.4-41,41v177.4 c0,22.5,18.4,41,41,41h188v-36.4H225.2z M264.9,190.2h74.7c10.3,0,18.6,8.4,18.6,18.6s-8.4,18.6-18.6,18.6h-74.7 c-10.3,0-18.6-8.4-18.6-18.6S254.6,190.2,264.9,190.2z M246.3,283.5c0-10.3,8.4-18.6,18.7-18.6h74.7c10.3,0,18.6,8.4,18.6,18.6l0,0 c0,10.3-8.4,18.6-18.6,18.6h-74.7C254.6,302.1,246.3,293.8,246.3,283.5L246.3,283.5z"
});

var SvgOxyEducacional = function SvgOxyEducacional(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOxyEducacional, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oxy-educacional.19eb9164.svg";
export { ForwardRef as ReactComponent };